import { FunctionComponent } from 'react';
import './features-3.scss';
import BuyNowButton from '../../shared/buy-now-button/buy-now-button';
import H2 from '../../shared/html-tags/h2';
import H1 from '../../shared/html-tags/h1';
import DIV from '../../shared/html-tags/div';
import { Box } from '@mui/material';

export type Props = {};

const Features3TopBanner: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <Box
      className="page-content bg-top-features-3 top-banner"
      sx={{
        height: { md: '25.25rem', xs: 'auto !important' },
        display: 'flex',
      }}
    >
      <div className="inner-content">
        <Box
          className="top-left"
          sx={{
            display: 'flex',
            justifyContent: 'stretch',
            alignItems: 'center',
            marginLeft: '-8rem',
            paddingLeft: '8rem',
            backgroundImage: 'url(/img/features/3/28-bang-300x300.png)',
            backgroundPosition: '0 17rem',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '12.5rem',
            height: { md: '25.25rem', xs: 'auto !important' },
          }}
        >
          <div>
            <H2 language="de">
              SPSS + Predictive Solutions = PS IMAGO <b style={{ color: 'crimson' }}>PRO</b>
            </H2>
            <H1 language="de" style={{ lineHeight: '1.25' }}>
              Mehr Power für deine
              <br />
              explorative Datenanalyse & <br />
              Statistik Ergebnispräsentation
            </H1>
            <H2 language="de" style={{ fontSize: '1.25rem', marginTop: '0.5rem' }}>
              Erziele schneller, präzisere Ergebnisse,
              <br />
              während du Zeit und Kosten sparst.
            </H2>
            <BuyNowButton order={'buy'} />
          </div>
        </Box>
        <DIV language="de" className="top-right">
          <img
            src="/img/features/3/p3-542x500.png"
            alt="Roboter liest die 2x4 PS IMAGO PRO News"
            style={{ border: 'none', marginTop: '0', maxHeight: '24.5rem' }}
          />
        </DIV>
      </div>
    </Box>
  );
};

export default Features3TopBanner;
